import ItemService from '@/services/ItemService'
import ItemModel from '@/models/ItemModel'
import SectionModel from '@/models/SectionModel'
import Mtxs from '@/constants/Mutations'

import { TIP_ITEM_NAME, ALL_APP_ITEM_NAMES } from '@/constants/AppItemNames'
import _sortBy from 'lodash/sortBy'
import _includes from 'lodash/includes'
import _get from 'lodash/get'

export const state = {
  sections: [],
  items: [],
} // state

export const mutations = {
  [Mtxs.SET_ITEMS](state, items) {
    ItemModel.insert({ data: items })
  },
  [Mtxs.SET_ITEM_STOCK](state, { id, stock }) {
    ItemModel.update({ id, stock })
  },
  [Mtxs.SET_SECTIONS](state, sections) {
    SectionModel.insert({ data: sections })
  },
} // mutations

export const getters = {
  getSections: () =>
    SectionModel.query()
      .with('items')
      .orderBy('order')
      .all(),
  getSectionNameById: () => (id) => {
    let section = SectionModel.find(id)
    return _get(section, 'name', '')
  },

  getItems: () =>
    ItemModel.query()
      .with('section')
      .get(),
  getItemById: () => (id) => ItemModel.find(id),
  getItemByName: () => (name) =>
    ItemModel.query()
      .where('name', name)
      .first(),
  getRealItems: () =>
    ItemModel.query()
      .where((i) => !_includes(ALL_APP_ITEM_NAMES, i.name))
      .get(),
  getCategorizedItems: (state, getters) => {
    let bySection = {}
    _sortBy(getters.getSections, 'order').map(
      (c) =>
        (bySection[c.name] = c.items
          ? c.items
              .map((itemId) =>
                getters.getItems.find((item) => item.id === itemId)
              )
              .filter((i) => !!i)
          : [])
    )
    return bySection
  },
  getTipItem: (_, getters) => getters.getItemByName(TIP_ITEM_NAME),
} // getters

export const actions = {
  async fetchItems() {
    try {
      await ItemModel.fetchForShop()
    } catch (error) {
      throw Error(error)
    }
  }, // fetchItems

  async findItems(context, ids) {
    try {
      let items = await ItemService.findItems(ids)
      return items
    } catch (error) {
      throw Error(error)
    }
  }, // findItems

  async setItemsStock({ commit }, itemsWithStock) {
    itemsWithStock.map((i) => {
      commit(Mtxs.SET_ITEM_STOCK, { id: i.id, stock: i.stock })
    })
  }, // setItemsStock

  async fetchSections() {
    try {
      await SectionModel.fetchForShop()
    } catch (error) {
      throw Error(error)
    }
  }, // fetchSections

  async rearrangeMenu(_, updatedMenuArrangement) {
    try {
      let res = await SectionModel.rearrangeMenu(updatedMenuArrangement)
      return res
    } catch (error) {
      return Promise.reject(error)
    }
  }, // fetchSections
} // actions
